import React, { Component } from 'react';
import PianoRollComponent from 'components/pianoroll/PianoRollComponent.js';
import ToolbarMixButtons from 'components/toolbar/ToolbarMixButtons.js';

class PianoRollDocumentation extends Component {
    constructor(props) {
        super(props);
    }

    get track() {
        return this.props.sequencerEngine.tracks[0];
    }

    get pianoRollComponent() {
        if (this.track) {
            return (
                <PianoRollComponent
                  hideToolbar={true}
                  track={this.props.sequencerEngine.tracks[0]}
                  sequencerEngine={this.props.sequencerEngine}/>
            );
        }
        return (<div></div>);
    }

    render() {
        return (
            <div>
              <p>
                Once you've gotten comfortable with the step-sequencer, you'll find yourself wanting to write melodies
                more directly. Thats where the piano roll comes in handy.
              </p>
              <p>
                To view the piano roll, click the piano-roll button at the top toolbar of the sequencer:
                <div>
                  <ToolbarMixButtons sequencerEngine={this.props.sequencerEngine}/>
                </div>
                <div className="clear-fix"/>
              </p>
              <p>
                When clicked, a piano roll will appear at the bottom of your screen, controlling the selected track.
                It looks like this:
                {this.pianoRollComponent}
              </p>
              <p className="sub-header">
                Basics
              </p>
              <p>
                <ul>
                  <li>
                    Double click to add notes to the piano roll
                  </li>
                  <li>
                    Click on an existing trigger to select it. Click once more to delete it.
                  </li>
                  <li>
                    Hover over the right-edge of a step and drag to change the duration
                    of a particular step.
                  </li>
                  <li>
                    Drag an area to select steps
                  </li>
                  <li>
                    Type the "delete" key to delete selected steps
                  </li>
                </ul>
              </p>
              <p className="sub-header">
                Scolling
              </p>
              <p>
                Use your trackpad to scroll up and down in a piano roll.
              </p>
              <p className="sub-header">
                Zooming In/Out
              </p>
              <p>
                Trackpad gestures are also supported for zooming in and out, along with dragging the mouse horizontally on the left bar of the piano roll.
              </p>
            </div>
        );
    }
}

export default PianoRollDocumentation;
